enum CustomerTypeEnum
{
    Undefined = 0,
    Professional,
    Particular
}

export default CustomerTypeEnum;